import {Component, Input} from '@angular/core';
import {MatDialog} from "@angular/material";
import {kanMailsService} from "../../../services/services/mails";
import {Mail} from "../../../../classes/mail";
import {kanMailDialog} from "../../dialogs/mail-dialog/component";

@Component({
    selector: 'kan-mails',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanMails {

    @Input() public selectedTab: number;
    public mails: Mail[];

    constructor(private dialog: MatDialog, private mailsService: kanMailsService) {
    }

    ngOnInit(): void {
        this.getMails();
    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === 0) {
            this.getMails();
        }
    }

    public newMail(event: any) {
        let dialogRef = this.dialog.open(kanMailDialog, {
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getMails();
            }
        });
    }

    public getMails(): void {
        this.mailsService.getMails()
            .then((mails: Mail[]) => {
                this.mails = mails;
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/mails/components/mails/component.ts